import PropTypes from 'prop-types';
import styled from 'styled-components';

import { config } from '_config';
import { theme } from '_constants/theme';

import * as Layout from '_components/atomic/layouts';
import JoinBanner from '../JoinBanner';

export const topReasonsToUseProfessionalRegisteredAgentServiceContents = [
  'Ensures Legal Compliance',
  'Protect Your Privacy',
  'Provides a Reliable Point of Contact',
  'Maintains Flexibility',
  'Offers Professional Expertise',
];

const StyledContainer = styled.div`
  position: relative;
`;

const StyledBlock = styled.div`
  position: relative;
  z-index: 1;

  ol,
  ul {
    padding-top: ${theme.spaces.regular}px;

    li {
      margin-bottom: ${theme.spaces.regular}px;

      &::marker {
        font-weight: 700;
      }
    }
  }
`;

const StyledBackgroundImageContainer = styled.div`
  position: absolute;
  top: 40%;
  width: 100%;

  img {
    width: 100%;
  }
`;

const TopReasonsToUseProfessionalRegisteredAgentServiceArticle = ({
  idPrefix,
}) => {
  return (
    <StyledContainer>
      <Layout.Card.Text>
        When starting and running a business, there are numerous legal and
        administrative tasks to manage. One crucial but often overlooked aspect
        is appointing a registered agent. A registered agent plays a vital role
        in ensuring that your business complies with state regulations and stays
        informed of legal obligations. Here are the top reasons to use a
        professional registered agent service for your business.
      </Layout.Card.Text>
      <Layout.Divider />
      <StyledBlock id={`${idPrefix}-${0}`}>
        <Layout.Card.Text
          as="h1"
          size={theme.fontSizes.large}
          color={theme.colors.indigo[600]}
          boldest
          centered
          underline
        >
          Ensures Legal Compliance
        </Layout.Card.Text>
        <Layout.Card.Text>
          A registered agent is responsible for receiving important legal
          documents, such as lawsuits, subpoenas, and other official notices. By
          using a professional registered agent service, you can ensure that
          these critical documents are handled promptly and correctly. This
          helps you avoid the risk of missing important deadlines or legal
          requirements, which could result in penalties or legal complications.
          Incorpified’s registered agent service guarantees that you stay
          compliant with all state regulations, providing peace of mind that
          your business is always in good standing.
        </Layout.Card.Text>
      </StyledBlock>
      <Layout.Divider />
      <StyledBlock id={`${idPrefix}-${1}`}>
        <Layout.Card.Text
          as="h1"
          size={theme.fontSizes.large}
          color={theme.colors.indigo[600]}
          boldest
          centered
          underline
        >
          Protects Your Privacy
        </Layout.Card.Text>
        <Layout.Card.Text>
          When you serve as your own registered agent, your personal address
          becomes part of the public record. This can lead to unwanted
          solicitations and potential privacy concerns. A professional
          registered agent service uses their address instead, keeping your
          personal information private and off public records. Incorpified’s
          registered agent service ensures that your home address remains
          confidential, protecting your privacy and personal security.
        </Layout.Card.Text>
      </StyledBlock>
      <Layout.Divider />
      <StyledBlock id={`${idPrefix}-${2}`}>
        <Layout.Card.Text
          as="h1"
          size={theme.fontSizes.large}
          color={theme.colors.indigo[600]}
          boldest
          centered
          underline
        >
          Provides a Reliable Point of Contact
        </Layout.Card.Text>
        <Layout.Card.Text>
          A registered agent must be available during standard business hours to
          receive legal and government documents. This can be challenging for
          business owners who are often on the move or have irregular schedules.
          A professional registered agent service offers a consistent and
          reliable point of contact, ensuring that you never miss important
          communications. With Incorpified’s registered agent service, you can
          focus on running your business without worrying about missing critical
          documents or being tied to a specific location.
        </Layout.Card.Text>
      </StyledBlock>
      <Layout.Divider />
      <StyledBlock id={`${idPrefix}-${3}`}>
        <Layout.Card.Text
          as="h1"
          size={theme.fontSizes.large}
          color={theme.colors.indigo[600]}
          boldest
          centered
          underline
        >
          Maintains Flexibility
        </Layout.Card.Text>
        <Layout.Card.Text>
          Using a professional registered agent service allows you to maintain
          flexibility in your business operations. You can change your business
          address or move to a new location without needing to update your
          registered agent information with the state. This is particularly
          beneficial for home-based businesses or those that operate in multiple
          states. Incorpified’s registered agent service provides the
          flexibility you need to grow and adapt your business without the
          hassle of constant paperwork updates.
        </Layout.Card.Text>
      </StyledBlock>
      <Layout.Divider />
      <StyledBlock id={`${idPrefix}-${4}`}>
        <Layout.Card.Text
          as="h1"
          size={theme.fontSizes.large}
          color={theme.colors.indigo[600]}
          boldest
          centered
          underline
        >
          Offers Professional Expertise
        </Layout.Card.Text>
        <Layout.Card.Text>
          Registered agent services often come with additional benefits, such as
          compliance monitoring and document management. These services ensure
          that you are aware of filing deadlines and other regulatory
          requirements, helping you stay on top of your administrative
          responsibilities. The expertise of a professional registered agent
          service can be invaluable in navigating the complexities of business
          compliance. Incorpified’s registered agent service not only handles
          your legal documents but also provides expert guidance and support to
          help you maintain compliance and avoid common pitfalls.
        </Layout.Card.Text>
      </StyledBlock>
      <Layout.Divider />
      <Layout.Card.Text>
        Appointing a professional registered agent service is a smart decision
        for any business owner. It ensures legal compliance, protects your
        privacy, provides a reliable point of contact, maintains flexibility,
        and offers professional expertise. By choosing a trusted service like
        Incorpified, you can focus on growing your business with the confidence
        that your legal and administrative needs are well-managed.
      </Layout.Card.Text>
      <JoinBanner />
      <StyledBackgroundImageContainer>
        <picture>
          <source
            srcSet={`${config.basePath}/images/blog-arrow-logo2.svg`}
            type="image/svg+xml"
          />
          <img
            src={`${config.basePath}/images/blog-arrow-logo2.svg`}
            alt="Background Logo"
          />
        </picture>
      </StyledBackgroundImageContainer>
    </StyledContainer>
  );
};

TopReasonsToUseProfessionalRegisteredAgentServiceArticle.propTypes = {
  idPrefix: PropTypes.string,
};

export default TopReasonsToUseProfessionalRegisteredAgentServiceArticle;
